// pageTypeList List
const pageTypeList = [
    { value: 1, text_en: 'Static', text_bn: 'পরিবর্তনহীন' },
    { value: 2, text_en: 'Dynamic', text_bn: 'পরিবর্তনশীল' }
]

export default {
    pageTypeList
}
